import axiosInstance from '../axiosInstance';

const get = async () => {
  return axiosInstance.get('/tournament').then((response) => {
    return response.data;
  });
};

const getById = async (tournamentId) => {
  return axiosInstance.get(`/tournament/${tournamentId}`).then((response) => {
    return response.data;
  });
};

const create = async (tournament) => {
  return axiosInstance.post('/tournament', tournament).then((response) => {
    return response.data;
  });
};

const update = async (tournamentId, tournament) => {
  return axiosInstance.put(`/tournament/${tournamentId}`, tournament).then((response) => {
    return response.data;
  });
};

const remove = async (tournamentId) => {
  return axiosInstance.delete(`/tournament/${tournamentId}`).then((response) => {
    return response.data;
  });
};

const tournamentService = {
  get,
  getById,
  create,
  update,
  remove
};

export default tournamentService;
